import {Mesh, Object3D, Vector3} from "three";
import * as Globals from "./globals";
import * as SceneManager from './sceneManager';
import {clearGroup, initScene, setContinueRender} from './sceneManager';
import {ifcLoader, loadModel} from './utils/modelLoader';
import {setObjectLayer} from "./utils/layerUtils";
import {cursorTarget, setCursor, throttle} from "./utils/utils";
import {
    applyWallMovement,
    clearWallMovementState,
    generateMoveWallPreview,
    resetWallMovement,
    startWallMovement
} from "./models/walls/moveWallMode";
import {createGroup, findChildrenByName, getMouseCoordinates, getMousePosition} from "./utils/threeUtils";
import {
    activateFurnitureObject,
    deleteFurniture,
    generateFurniturePreview,
    repositionOptionsContainer,
    showFurnitureOptionsContainer
} from "./models/furniture/furniture";
import {
    adjustCutOutPreview,
    clearCutOutPreview,
    cutOutTypes as cutOutTypes,
    generateCutOut,
    getCutOutPreview,
    recreateCutoutPreview,
    resetCutOutPreview
} from "./models/cutOuts/cutOutGeneration";
import {CutOut} from "./models/cutOuts/cutOut";
import {
    clearHighlightingState,
    getObjectFromMousePosition,
    highlightedObject,
    highlightedObjectType,
    highlightObject
} from "./utils/highlighting";
import {deleteRoof} from "./models/roofs/roof";
import {TransactionManager} from "./TransactionManager";
import {generateMeasurements} from "./models/measurements/measurementGeneration";
import {clearLiveMeasurementState, generateLiveMeasurement} from "./models/measurements/liveMeasurement";
import {deleteFloor, regenerateFloor} from "./models/floor/floorGeneration";
import {adjustWallPreview, clearWallPreviewState, updateWallSnapAxis, wallClick,createCopyWallPreview,adjustWallCopyPosition} from "./models/walls/wallGeneration";
import {measurementClick,adjustPointer} from "./models/measurements/manualMeasurementGeneration";
import {deleteWall} from "./models/walls/wall";
import {
    applyRoomName,
    changeRoomName,
    clearRoomState,
    createRooms,
    hideRoomNameInput,
    setCurrentRoom
} from "./models/rooms/roomGeneration";
import {
    adjustRoomLinePreview,
    clearRoomLineState,
    deleteRoomLine,
    roomLineClick
} from "./models/rooms/roomLineGeneration";
import {getDialog, makeDialogDraggable} from "../ui/dialogService";
import {attachGUIEvents} from "../ui/events/uiEvents";
import {attachResizeEvents} from "../ui/events/sceneResizeEvents";
import {
    clearRoofState,
    finishRoofPointSelection,
    regenerateRoof,
    selectRoofPoints,
    snapRoofPoint
} from "./models/roofs/roofGeneration";
import {reconstructUISettings} from "./utils/dialogUtils";
import {recalculateBuildingParameters} from "./calculators/buildingParameters/parameterCalculator";
import * as nameContants from "./constants/nameConstants";
import {roofGroupName} from "./constants/nameConstants";
import {wallMaterial} from "./constants/materialConstants";
import {
    adjustPillarPreview,
    clearPillarPreviewState,
    deletePillar,
    pillarClick,
    removeSupportedSupportBeams
} from "./models/pillar/pillarGeneration";
import {
    adjustBeamPreview,
    beamClick,
    clearBeamPreviewState,
    deleteBeam
} from "./models/supportBeam/supportBeamGeneration";
import {showMessage, showToast} from "../ui/ui";
import {t} from "../i18n";
import hopscotch from "hopscotch";
import {isOuterShellClosed} from "./utils/wallAnalyzer";

//import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js'


export const scenesContainer = document.getElementById('scenesContainer');
export const layoutView = document.getElementById('layoutView');
export const sceneView = document.getElementById('sceneView');
export const $layoutView = $('#layoutView');
export const $sceneView = $('#sceneView');
export var copyObj = null;
// Groups
export let baseSceneGroup, buildingGroup, furnitureGroup, highlightsGroup, measurementsGroup, tmpGroup,
    roomNamesGroup, roomGroup = null;
export let mousePosition, wallMeshHBE_L, wallMeshHBE, mteMesh080, mteMesh100, mteMesh120, mteMesh140,
    mteMesh160, mteMesh180, mteMesh200;

//Mode modifiers
export let standardWallChosen = true; // indicated whether a standard wall element is chosen
export let isOrthogonalMode = true;
export let isFreeWallMode = false;
export let isDeleteMode = false;
export const setIsDeleteMode = (isActive) => {
    isDeleteMode = isActive;
};
export let isDraggingObject = false; // für Drag-and-drop Platzierung von Möbeln
export const setIsDraggingObject = (isActive) => {
    isDraggingObject = isActive;
};

//TODO: Beim entfernen von Elementen ggf Geometrie dispose und das Objekt selbst
//Erweiterung der .add() Methode → Fügt die UUID des Objekts zusätzlich in userData ein → Für Speichern/Laden
Object3D.prototype.addWithUuid = function (addedElement) {
    if (addedElement !== null) {
        addedElement.userData.uuid = addedElement.uuid.toString();
    }
    if (this === null || addedElement === null) {
        return;
    }
    let added = Object3D.prototype.add.call(this, addedElement);
    elementAdded(this);

    return added;
};

function elementAdded(addedTo) {
    if (addedTo.type === "Group") {
        if (addedTo.name === "furnitureGroup") {
            setObjectLayer(furnitureGroup, Globals.layers.furniture, true); //Layer aller Gruppenelemente setzen
        } else if (addedTo.name === "roomNamesGroup") {
            setObjectLayer(roomNamesGroup, Globals.layers.roomNames, true); //Layer aller Gruppenelemente setzen
        }
    }
}

/*Programmstart*/
$(function () {
    if (window.__configuratorMobileBlocked) {
        return;
    }
    initScene().then(() => {
        mousePosition = getMousePosition();
        console.log("Scene initialized");
        //$('#outerWallBtn').trigger('click');
        // enableAllLayers(sceneCamera)
    });

    makeDialogDraggable($('.build-element-dialog'));
    makeDialogDraggable($('#furniture-dialog'));
});

export function initializeGroups() {
    baseSceneGroup = createGroup("baseSceneGroup", SceneManager.scene);
    buildingGroup = createGroup("buildingGroup", SceneManager.scene);
    tmpGroup = createGroup("tmpGroup", SceneManager.scene);
    furnitureGroup = createGroup("furnitureGroup", SceneManager.scene);
    measurementsGroup = createGroup("measurementsGroup", SceneManager.scene);
    highlightsGroup = createGroup("highlightingGroup", SceneManager.scene);
    roomNamesGroup = createGroup("roomNamesGroup", SceneManager.scene);
    roomGroup = createGroup("roomGroup", SceneManager.scene);
}

export function rebindGroup(group) {
    let name = group.name;

    /*BaseSceneGroup wird nicht neu gebindet. Diese kann beibehalten werden aus der aktuellen Szene statt der geöffneten*/
    if (name === "buildingGroup") {
        buildingGroup = group;
    } else if (name === "tmpGroup") {
        tmpGroup = group;
    } else if (name === "measurementsGroup") {
        measurementsGroup = group;
    } else if (name === "furnitureGroup") {
        furnitureGroup = group;
    } else if (name === "highlightingGroup") {
        highlightsGroup = group;
    } else if (name === "roomNamesGroup") {
        roomNamesGroup = group;
    } else if (name === "roomGroup") {
        roomGroup = group;
    }
}

export function overwriteGroup(group, data) {
    clearGroup(group);
    if (data === null) {
        return;
    }
    for (let i = data.children.length - 1; i >= 0; i--) {
        group.addWithUuid(data.children[i]);
    }
}

export async function initBlocks() {
    wallMeshHBE_L = await initWallBlock(Globals.blockFolder + "HBE_L.ifc", "HBE_L");
    wallMeshHBE = await initWallBlock(Globals.blockFolder + "HBE_S.ifc", "HBE_S");
    mteMesh080 = await initWallBlock(Globals.blockFolder + "MTE Decken-80mm.ifc", "MTE_L_080", false);
    mteMesh100 = await initWallBlock(Globals.blockFolder + "MTE Decken-100mm.ifc", "MTE_L_100", false);
    mteMesh120 = await initWallBlock(Globals.blockFolder + "MTE Decken-120mm.ifc", "MTE_L_120", false);
    mteMesh140 = await initWallBlock(Globals.blockFolder + "MTE Decken-140mm.ifc", "MTE_L_140", false);
    mteMesh160 = await initWallBlock(Globals.blockFolder + "MTE Decken-160mm.ifc", "MTE_L_160", false);
    mteMesh180 = await initWallBlock(Globals.blockFolder + "MTE Decken-180mm.ifc", "MTE_L_180", false);
    mteMesh200 = await initWallBlock(Globals.blockFolder + "MTE Decken-200mm.ifc", "MTE_L_200", false);
}

async function initWallBlock(fileName, name, rotateY = true) {
    let tmp = await loadModel(ifcLoader, fileName);
    let mesh = new Mesh(tmp.geometry, wallMaterial);

    //base position of mesh
    mesh.geometry.center();
    mesh.geometry.computeBoundingBox();
    if (rotateY) {
        mesh.geometry.rotateY(Math.PI);
    }
    mesh.userData.blockName = name;
    return mesh;
}

//TODO: Eventstruktur benötigt Refactoring; highlighted object wird nicht nur für highlighting genutzt,
// object from mouseposition sollte an einige stellen stattdessen genutzt werden und bei klick gespeichert bleiben können.
// MousePosition als gespeicherter Export kann eigentlich direkt über Funktion aufgerufen werden wenn benötigt
//Drag einheitlich bestimmen

/* auto translated to english */

//TODO: Event structure requires refactoring; highlighted object is not only used for highlighting,
// object from mouseposition should be used instead in some places and remain saved when clicked.
// MousePosition as saved export can actually be called directly via function if required
//Drag standardised


export function attachUIEvents() {
    //UI Events
    //left side
    //transformControls = new TransformControls(SceneManager.layoutCamera, layoutView);
    
    layoutView.onmousemove = mouseMove;
    //right side ( preview )
    sceneView.onmousemove = sceneMouseMove;

    //Pausiere Rendering wenn keine Events im Body passieren. Alle 100ms trotzdem einen Frame rendern für nicht gecatchte Events
    //TODO: Weiter optimieren auf controls oder ähnliches binden oder scene change?
    /* auto translated to english */
    
    //Pause rendering if no events happen in the body. Still render a frame every 100ms for events that have not been caught
    //TODO: Further optimise to bind controls or similar or scene change?
  
    let body = document.getElementsByTagName('body')[0];
    body.onmousemove = mouseMoveWindow;

    attachResizeEvents();
    attachGUIEvents();
    syncShellMenu();
}

let mouseMoveWindow = function () {
    setContinueRender(true);
};

//Furniture drag&drop   
let leftDrag = false;
let rightDrag = false;
let isLeftDown = false;
let isRightDown = false;
let initializingDrag = false;
let initialPosition = null;

let initialRightPosition = null;


//let selectedObject;
//let isResizing = false;
//let resizeHandle = null;




//Preview

let sceneMouseMove = throttle(function (e) {
    
    checkForDrag(e);
});

let mouseMove = throttle(function (e) {
    
    setContinueRender(true);
    SceneManager.raycaster.setFromCamera(getMouseCoordinates(e, layoutView), SceneManager.layoutCamera);
    mousePosition = getMousePosition();
    if (mousePosition === undefined) {
        return;
    }

    checkForDrag(e);
    /*if (isResizing) {
        //handleWallResize();
    } else*/ if (initialPosition !== null && !isDeleteMode) {
        if (checkMode(Globals.modes.view)) {
            if (!leftDrag) {
                if (highlightedObjectType === nameContants.wallGroupName) {
                    TransactionManager.startTransaction();
                    startWallMovement(highlightedObject, new Vector3().copy(highlightedObject.position));
                    Globals.setActiveMode(Globals.modes.moveWall);
                } else if (highlightedObjectType === "room") {
                    setCurrentRoom(highlightedObject);
                }
            } else if (leftDrag && !initializingDrag) {
                initializingDrag = true;
                //Wenn ein Objekt bereits gehighlightet ist mit dem Arbeiten
                if (highlightedObject !== null) {
                    clearLiveMeasurementState();

                    TransactionManager.startTransaction();

                    if (highlightedObjectType === "cutOut") {
                        recreateCutoutPreview(cutOutTypes.cutOut, highlightedObject);
                    } else if (highlightedObjectType === "exteriorDoor") {
                        recreateCutoutPreview(cutOutTypes.exteriorDoor, highlightedObject);
                    } else if (highlightedObjectType === "interiorDoor") {
                        recreateCutoutPreview(cutOutTypes.interiorDoor, highlightedObject);
                    } else if (highlightedObjectType === "window") {
                        recreateCutoutPreview(cutOutTypes.window, highlightedObject);
                    }

                    TransactionManager.stopTransaction();

                    return;
                }

                //Prüfen, ob andere Elemente gehovert werden die nicht gehighlightet werden
                let data = getObjectFromMousePosition();
                if (data.object === null) {
                    return;
                }

                if (data.type === "furniture") {
                    clearLiveMeasurementState();
                    TransactionManager.startTransaction();
                    isDraggingObject = true;
                    activateFurnitureObject(isDraggingObject);
                }
            }
        }
    }

    if (checkMode(Globals.modes.view) || checkMode(Globals.modes.measurement)) {
        let data = getObjectFromMousePosition();
        highlightObject(data);
        //selectedObject = data.object;
        //attachTransformControls();
        if (checkMode(Globals.modes.view)){
            generateLiveMeasurement(data);
        }
    }
   /*  if (isDeleteMode) {

    } else */ if (checkMode(Globals.modes.wall)) {
        adjustWallPreview();
    } else if (checkMode(Globals.modes.moveWall)) {
        generateMoveWallPreview(highlightedObject);
    } else if (checkMode(Globals.modes.roomSeparation)) {
        adjustRoomLinePreview();
    } else if (checkMode(Globals.modes.roof)) {
        mousePosition = snapRoofPoint().snapPoint;
    } else if (checkMode(Globals.modes.cutOut)) {
        adjustCutOutPreview();
    } else if (checkMode(Globals.modes.furniture)) {
        if (isDraggingObject) {
            generateFurniturePreview();
        }
        repositionOptionsContainer();
    } else if (checkMode(Globals.modes.pillar)) {
        adjustPillarPreview();
    } else if (checkMode(Globals.modes.beam)) {
        adjustBeamPreview();
    } else if (checkMode(Globals.modes.copyWall)) {
        adjustWallCopyPosition(mousePosition)
    } else if (checkMode(Globals.modes.measurement)) {
        adjustPointer();
    }
}, Globals.throttleDuration);

$layoutView.on('mousedown', function (e) {
    initDragDrop(e);
});

$sceneView.on('mousedown', function (e) {
    initDragDrop(e);
});

$layoutView.on('mouseup', function (e) {
    //Übernahme von Möbel und Wandpositionen
    /*    if (checkMode(Globals.modes.furniture)) {
            mousePosition = getMousePosition();
            isDraggingObject = false;
            showFurnitureOptionsContainer(isDraggingObject);
        } else*/
    if (checkMode(Globals.modes.moveWall)) {
        applyWallMovement();
        TransactionManager.stopTransaction();
        Globals.setActiveMode(Globals.modes.view);
        generateMeasurements().then();
/*         if(selectedObject){
            //console.log(selectedObject);
            //selectedObject.userData.onDeselect();
            selectedObject = null;
        } */
    } else if(checkMode(Globals.modes.resizeWall)){
        //console.log(selectedObject);
        //selectedObject.userData.onDeselect();
        /* selectedObject = null;
        isResizing = false;
        resizeHandle = null; */
        
        TransactionManager.stopTransaction();
        Globals.setActiveMode(Globals.modes.view);
        generateMeasurements().then();
        clearStates();
    }

    clearLiveMeasurementState();

    if (e.button === 2 && !rightDrag) {
        escapeCommand();
    }

    endDragDrop(e);
});

$sceneView.on('mouseup', function (e) {
    let mouseCoords = getMouseCoordinates(e, sceneView);
    let data = getObjectFromMousePosition(true, mouseCoords);
    if (!leftDrag && e.button === 0) {
        if (isDeleteMode) {
            TransactionManager.startTransaction();
            deleteObject(data);
            TransactionManager.stopTransaction();
        }
    }


    if (e.button === 2 && !rightDrag) {
        escapeCommand();
    }

    endDragDrop(e);
});

$sceneView.on('click', function (e) {
    let mouseCoords = getMouseCoordinates(e, sceneView);
    let data = getObjectFromMousePosition(true, mouseCoords);
    if (checkMode(Globals.modes.view)) {
        checkForDialog(e, data);
    } else if (checkMode(Globals.modes.furniture)) {
        mousePosition = getMousePosition();
        isDraggingObject = false;
        showFurnitureOptionsContainer(isDraggingObject);
        TransactionManager.stopTransaction();
    }
});


/* function handleWallResize() {
    if (selectedObject && resizeHandle) {
        selectedObject.userData.OnResizeWall(resizeHandle, mousePosition);
        generateMeasurements().then();
        
    }
} */

function initDragDrop(e) {
    //TODO: Refactoring
    if (e.button === 2) {
        rightDrag = false;
        isLeftDown = false;
        isRightDown = true;

        
        initialRightPosition = {x: e.screenX, y: e.screenY};
    } else {
        leftDrag = false;
        isLeftDown = true;
        isRightDown = false;

        initializingDrag = false;
        initialPosition = {x: e.screenX, y: e.screenY};

        if (!isDeleteMode && checkMode(Globals.modes.view)) {
            let data = getObjectFromMousePosition();
            //console.log(data);
            if (data.type === "furniture") {
                activateFurnitureObject(true);
            } /* if (data.type === nameContants.wallGroupName) {
                selectedObject = data.object;
                //console.log(selectedObject);
                //selectedObject.userData.onSelect();
            } else  *//* if (data.type === "startHandle" || data.type === "endHandle") {
                isResizing = true;
                resizeHandle = data.object;
                Globals.setActiveMode(Globals.modes.resizeWall);
                TransactionManager.startTransaction();
                
            } */
        }
    }
}

function checkForDrag(e) {
    if (isLeftDown) {
        if (initialPosition !== null) {
            let newPosition = {x: e.screenX, y: e.screenY};
            if (Math.abs(initialPosition.x - newPosition.x) + Math.abs(initialPosition.y - newPosition.y) > 10) {
                leftDrag = true;

                if (checkMode(Globals.modes.furniture)) {
                    let data = getObjectFromMousePosition();
                    if (data.type === "furniture") {
                        if(!isDraggingObject)
                            TransactionManager.startTransaction();
                        setIsDraggingObject(true);
                    }
                }
            }
        }
    } else if (isRightDown) {
        if (initialRightPosition !== null) {
            let newPosition = {x: e.screenX, y: e.screenY};
            if (Math.abs(initialRightPosition.x - newPosition.x) + Math.abs(initialRightPosition.y - newPosition.y) > 10) {
                rightDrag = true;
            }
        }
    }
}

// eslint-disable-next-line no-unused-vars
function endDragDrop(_e) {
    leftDrag = false;
    rightDrag = false;
    isLeftDown = false;
    isRightDown = false;
    initialPosition = null;
    initializingDrag = false;
    initialRightPosition = null;
    
}

//Insert element
layoutView.onclick = function (e) {
    
    mousePosition = getMousePosition();
    if (mousePosition === undefined ) {
        return;
    }
    

    clearLiveMeasurementState();
    let data = getObjectFromMousePosition();

    if (isDeleteMode) {
        TransactionManager.startTransaction();
        deleteObject(data);
        TransactionManager.stopTransaction();
        generateMeasurements().then();
    } else if (checkMode(Globals.modes.wall)) {
        wallClick(!e.ctrlKey);
        TransactionManager.stopTransaction();
    } else if (checkMode(Globals.modes.measurement)) {
        measurementClick();
        TransactionManager.stopTransaction();
    } else if (checkMode(Globals.modes.pillar)) {
        pillarClick();
        TransactionManager.stopTransaction();
    } else if (checkMode(Globals.modes.beam)) {
        beamClick();
    } else if (checkMode(Globals.modes.cutOut)) {
        generateCutOut();
        TransactionManager.stopTransaction();
    } else if (checkMode(Globals.modes.furniture)) {
        isDraggingObject = false;
        activateFurnitureObject(isDraggingObject);
        Globals.setActiveMode(Globals.modes.view);
        TransactionManager.stopTransaction();
    } else if (checkMode(Globals.modes.roof)) {
        TransactionManager.startTransaction();
        let loopClosed = selectRoofPoints();
        if (loopClosed) TransactionManager.stopTransaction();
    } else if (checkMode(Globals.modes.roomSeparation)) {
        roomLineClick();
    } else if (checkMode(Globals.modes.roomLabeling)) {
        changeRoomName(e, data.object);
    } /* else if (checkMode(Globals.modes.furniture)) {
        Globals.setActiveMode(Globals.modes.view);
    } */ else if (checkMode(Globals.modes.copyWall)) {
        TransactionManager.startTransaction();
        wallClick(/*placeWall*/true,/*usePreviewLength*/true);
        //clearStates();
        //Globals.setActiveMode(Globals.modes.view);
        TransactionManager.stopTransaction();
    } else {
        checkForDialog(e, data);
    }
};

sceneView.onclick = function (e) {
    SceneManager.raycaster.setFromCamera(getMouseCoordinates(e, sceneView), SceneManager.sceneCamera);
    mousePosition = getMousePosition();
    if (mousePosition === undefined) {
        return;
    }

    if (checkMode(Globals.modes.furniture)) {
        Globals.setActiveMode(Globals.modes.view);
    }

    if (e.button === 2) {
        escapeCommand();
    }
};

export let currentDialogObject = null;
export const setCurrentDialogObject = (obj) => {
    currentDialogObject = obj;
};

function checkForDialog(e, data) {
    if (data.type === null || data.object === null) {
        return;
    }

    if (e.button !== 0) {
        return;
    }

    currentDialogObject = {object: data.object, originalParent: data.object.parent};
    //Wenn Mausklick beendet wird und kein Drag&Drop gestartet wurde dann Dialog einblenden
    let dialogId = null;
    if (data.object.parent.name.includes("cutOut")) {
        dialogId = getDialog(scenesContainer, null, 'cut-out-draggable-dialog', e);
    } else if (data.object.parent.name.includes("exteriorDoor")) {
        dialogId = getDialog(scenesContainer, null, 'exterior-door-draggable-dialog', e);
    } else if (data.object.parent.name.includes("interiorDoor")) {
        dialogId = getDialog(scenesContainer, null, 'interior-door-draggable-dialog', e);
    } else if (data.object.parent.name.includes("window")) {
        dialogId = getDialog(scenesContainer, null, 'window-draggable-dialog', e);
    } else if (data.type === "roof") {
        dialogId = getDialog(scenesContainer, null, 'roof-draggable-dialog', e);
    } else if (data.type === "floor") {
        dialogId = getDialog(scenesContainer, null, 'floor-draggable-dialog', e);
    } else if (data.type === "pillar") {
        if (!data.object.userData.automaticallyPlaced) {
            dialogId = getDialog(scenesContainer, null, 'pillar-draggable-dialog', e);
        } else {
            showToast(t("pillar_auto_locked"));
        }
    } else if (data.type === "beam") {
        showMessage(t("beam_cannot_edit"), "Hinweis");
        // dialogId = getDialog(scenesContainer, null, 'beam-draggable-dialog', e);
    }
    if (dialogId !== null) {
        reconstructUISettings(dialogId.attr('id'));
    }
}


//Key presses throttlen aus Performance Gründen bei Undo/Redo sonst nicht
document.onkeydown = function (e) {
    if (e.code === "ShiftLeft") {
        isFreeWallMode = true;
    } else if (e.code === "ControlLeft") {
        //isOrthogonalMode = false; //Zunächst nur orthogonale Wände
    } else if (e.code === "Escape") {
        escapeCommand();
    } else if (e.code === "Enter" || e.code === "NumpadEnter") {
        if (checkMode(Globals.modes.roof)) {
            finishRoofPointSelection();
        } else if(checkMode(Globals.modes.roomLabeling)){
            applyRoomName($('#label-room-input').val());
        }
    } else if (e.key === 'z' && e.ctrlKey === true) {
        throttledKeyDown(e);
    } else if (e.key === 'y' && e.ctrlKey === true) {
        throttledKeyDown(e);
    }

    if (e.key == 'Delete') {
        if (highlightedObject) {
            TransactionManager.startTransaction();
            if (cutOutTypes[highlightedObjectType] !== undefined) {
                deleteObject({object: highlightedObject, type: 'controlObject'});    
            } else {
                deleteObject({object: highlightedObject, type: highlightedObjectType});
            }
            TransactionManager.stopTransaction();
        }
    }

    if (e.key === 'c' && e.ctrlKey === true) {
        if (! highlightedObject) {
            return;
        }
        
        copyObj = {object: highlightedObject, type: highlightedObjectType};
    }

    if (e.key === 'v' && e.ctrlKey === true) {
        if (!copyObj) {
            return;
        }

        let pasteObject = {
            object: copyObj.object.clone(),
            type: copyObj.type
        };

        if (copyObj.type == nameContants.wallGroupName) {
            createCopyWallPreview(pasteObject.object);
        } else if (cutOutTypes[copyObj.type] !== undefined) {
            let windowWidth = pasteObject.object.userData.width;
            let windowHeight = pasteObject.object.userData.height;
            TransactionManager.startTransaction();
            resetCutOutPreview();
            getCutOutPreview(cutOutTypes[copyObj.type], windowWidth, windowHeight);
            TransactionManager.stopTransaction();
        }
    }
};

let throttledKeyDown = throttle(function throttledKeyDown(e) {
    if (e.key === 'z' && e.ctrlKey === true) {
        TransactionManager.undo();
    } else if (e.key === 'y' && e.ctrlKey === true) {
        TransactionManager.redo();
    }
}, Globals.keyThrottleDuration);

document.onkeyup = function (e) {
    if (e.code === "ShiftLeft") {
        isFreeWallMode = false;
    } else if (e.code === "ControlLeft") {
        isOrthogonalMode = true;
    }
};

export function escapeCommand() {
//Commands beenden
    toggleModeButtons();

    if (checkMode(Globals.modes.moveWall)) {
        resetWallMovement(highlightedObject);
        generateMeasurements().then();
    } else if (checkMode(Globals.modes.wall) || checkMode(Globals.modes.beam)) {
        createRooms().then();
        regenerateRoof().then();
        regenerateFloor().then();
        generateMeasurements().then();
    }

    hideRoomNameInput();
    resetCutOutPreview();
    setCurrentDialogObject(null);
    clearStates();
    setCurrentRoom(null);
    TransactionManager.abortTransaction();
    recalculateBuildingParameters().then();
}

//Checks if the given mode is the currently active mode
export function checkMode(mode) {
    return Globals.activeMode === mode;
}

export function toggleModeButtons() {
    if (isDeleteMode) {
        isDeleteMode = false;
    }

    $('.control-element').removeClass('active').trigger('mouseleave');
    syncShellMenu();
}

// The left menu stays limited to the shell tools only until the first closed outline exists.
// Later edits do not lock it again.
let shellEstablished = false;

function projectHasLeftTheFirstShell() {
    if (!buildingGroup) {
        return false;
    }

    const walls = findChildrenByName(buildingGroup, nameContants.wallGroupName, false, true) || [];
    for (let i = 0; i < walls.length; i++) {
        if (walls[i].userData && walls[i].userData.isOuterWall === false) {
            return true;
        }
    }

    const roofs = findChildrenByName(buildingGroup, nameContants.roofGroupName, false, true) || [];
    const floors = findChildrenByName(buildingGroup, nameContants.floorGroupName, false, true) || [];
    return roofs.length > 0 || floors.length > 0;
}

export function resetShellMenu() {
    shellEstablished = false;
    if (buildingGroup && buildingGroup.userData) {
        buildingGroup.userData.shellEstablished = false;
    }
}

export function syncShellMenu(force = false) {
    if (!force && hopscotch.getCurrTour()) {
        return;
    }

    if (!shellEstablished && buildingGroup && buildingGroup.userData && buildingGroup.userData.shellEstablished) {
        shellEstablished = true;
    }
    if (!shellEstablished && (isOuterShellClosed() || projectHasLeftTheFirstShell())) {
        shellEstablished = true;
        if (buildingGroup) {
            buildingGroup.userData.shellEstablished = true;
        }
    }

    const shellTools = new Set(["outerWallBtn", "beamBtn", "deleteBtn"]);

    $('#sidebar-left .control-element').each(function () {
        if (this.id === "roomSplitBtn") {
            $(this).addClass("disabled");
            return;
        }

        if (shellEstablished || shellTools.has(this.id)) {
            $(this).removeClass("disabled");
        } else {
            $(this).addClass("disabled");
        }
    });
}

/* Muss vor der Erstellung einer Preview aufgerufen werden, um den aktuellen Stand aufzuräumen.
 * Sonst können alte Preview Objekte etc. in der Szene verbleiben die nicht mehr benötigt werden.
 * Setzt den View Mode. Dieser muss ggf. dann überschrieben werden
 * Jede Objektklasse brauch eine clear Methode um ihren aktuellen Stand rückstandlos zurückzusetzen und muss hier aufgerufen werden,
 */
export function clearStates() {
    clearCutOutPreview();
    clearRoomState();
    clearRoofState();
    clearWallPreviewState();
    clearWallMovementState();
    clearPillarPreviewState();
    clearBeamPreviewState();
    clearLiveMeasurementState();
    clearRoomLineState();
    SceneManager.clearGroup(tmpGroup);
    SceneManager.clearGroup(highlightsGroup);
    clearHighlightingState();
    Globals.setActiveMode(Globals.modes.view);
    document.querySelector('.manual-placement-instructions').style.display = 'none';
     toggleModeButtons();
    //if(selectedObject){
        //console.log(selectedObject);
        //selectedObject.userData.onDeselect();
    //    selectedObject = null;
    //}

    setCursor(Globals.cursors.default, cursorTarget.both);
}

function deleteObject(data) {
    if (data === null) {
        return;
    }

    if (highlightedObject !== null && highlightedObject === data.object) {
        clearHighlightingState();
    }

    let recalculatingBuildingParametersNeeded = false;
    let recalculateRoof = false;
    if (data.type === "controlObject") {
        data.object.userData.originalParent = data.object.parent.uuid; //TODO: Temp fix Parent kann teilweise nicht gefunden werden
        let wall = CutOut.clearOldCutOut(data.object);
        CutOut.adjustWall(wall);
        recalculatingBuildingParametersNeeded = true;
    } else if (data.type === nameContants.wallGroupName) {
        deleteWall(data.object);
        recalculatingBuildingParametersNeeded = true;
        recalculateRoof = true;
        updateWallSnapAxis();
    } else if (data.type === "floor") {
        deleteFloor(data.object);
        recalculatingBuildingParametersNeeded = true;
    } else if (data.type === "roof") {
        deleteRoof(data.object);
        recalculatingBuildingParametersNeeded = true;
    } else if (data.type === "furniture") {
        deleteFurniture(data.object);
    } else if (data.type === "roomLine") {
        deleteRoomLine(data.object);
    } else if (data.type === "pillar") {
        removeSupportedSupportBeams(data.object);
        deletePillar(data.object);
        updateWallSnapAxis();
        recalculateRoof = true;
        recalculatingBuildingParametersNeeded = true;
    } else if (data.type === "beam") {
        deleteBeam(data.object);
        let roof = findChildrenByName(buildingGroup, roofGroupName);
        if (roof.length > 0) {
            showMessage(t("beam_removed_static"), "Hinweis");
        }
        updateWallSnapAxis();
        recalculateRoof = true;
        recalculatingBuildingParametersNeeded = true;
    }

    if (recalculateRoof) {
        createRooms();
        regenerateRoof();
        regenerateFloor();
        generateMeasurements().then();
    }

    if (recalculatingBuildingParametersNeeded) {
        if (!recalculateRoof) {
            createRooms();
            generateMeasurements().then();
        }
        recalculateBuildingParameters().then();
    }

    syncShellMenu();
}
